(function ($, Drupal) {
  'use strict';

  /**
   * Trigger products slick carousel
   */
  Drupal.behaviors.artistryVideoPlayerCarouselV1 = {
    attach: function (context) {
      var carousel = $('.js-video-player__products-carousel', 'body');
      var productsSlide = '.carousel-slide';
      var arrowsDiv = $('.artistry-video-player__products .carousel-controls');
      var count = arrowsDiv.find('.count');
      var items = carousel.find('.carousel-slide').length;

      // render products in a carousel for wider than mobile
      if (Modernizr.mq('(min-width: 481px)') === true) {
        var isRTL = site.direction.isRTL && Drupal?.settings?.forceSlickRTL;
        // swipe/drag direction is opposite when in RTL
        // so better to just disable it until a fix is provided in the library
        var swipe = isRTL ? false : true;
        var draggable = swipe;

        carousel.slick({
          rtl: isRTL,
          swipe: swipe,
          draggable: draggable,
          appendArrows: arrowsDiv,
          autoplay: true,
          speed: 300,
          slide: productsSlide,
          slidesToShow: 1,
          slidesToScroll: 1,
          accessibility: true,
          onInit: function () {
            count.html('1/' + items);
          },
          onAfterChange: function () {
            var currentSlide = carousel.slickCurrentSlide() + 1;

            count.html(currentSlide + '/' + items);
          }
        });
      }
    }
  };

  /**
 * Trigger youtube player
 */
  var artistryVideoPlayerV1 = {
    createVideoPlayerDiv: function ($elem, i) {
      var id = $elem.attr('class') + '-' + i;

      $elem
        .append('<div />')
        .children('div')
        .attr('id', id);

      return id;
    },

    addVideo: function (ytId, iframeId) {
      /* global YT */
      var player = new YT.Player(iframeId, {
        height: '100%',
        width: '100%',
        videoId: ytId,
        playerVars: {
          empty: '', // Empty value to stop parameters being eaten by incorrect video IDs with parameters appended. See bug i291846
          controls: 1,
          showinfo: 0,
          rel: 0
        },
        events: {
          'onReady': function (event) {
            event.target.playVideo();
          },
          'onStateChange': function (event) {
          // stuff
          }
        }
      });
    },

    setup: function (event) {
      var self = this;

      $('.js-artistry-video-player').each(function (i) {
        var $me = $(this);
        var $content = $('.artistry-video-player__content', $me);
        var $vids = $content.filter(function (i) {
          return $(this).data('video-provider') === 'youtube' && $(this).data('youtube-id').length > 0;
        });
        var $player = $('.artistry-video-player__media--video', $content);
        var $playIcon = $('.artistry-video-player__media .play', $content);

        $vids.each(function () {
          var $wrap = $(this);
          var ytId = $wrap.attr('data-youtube-id');

          $wrap.keyup(function (e) {
            var keyCode = site.getKeycode(e);

            // Triggers click event on enter key press
            if (keyCode === 13) {
              $wrap.trigger('click');
            }
          });

          $wrap.click(function (e) {
            // Do something useless
            e.preventDefault();

            // Reset the current player wrapper
            // display play icon
            $player.removeClass('video-active').empty();
            $playIcon.removeClass('hidden').empty();

            // Create a new div for the player to take over
            var iframeId = self.createVideoPlayerDiv($player, Math.floor(+new Date() / 1000));

            // Add the 'active' class to the player for spacing
            // hide play icon
            $player.addClass('video-active');
            $playIcon.addClass('hidden');

            // Instantiate the video
            self.addVideo(ytId, iframeId);

            // Do something else that's useless
            return false;
          });
        });
      });
    }
  };

  $(document).bind('youtubeIframeAPI.loaded', function (e) {
    artistryVideoPlayerV1.setup(e);
  });
})(jQuery, Drupal);
